import Client from './Clients/AxiosClient';
const resource = '/api';

export default {
    datesForPrinting() {
        return Client.get(`${resource}/Dates`, {
            withCredentials: true, responseType: 'json'
          })
    },
    getShotAppointments(dateAndLocation) {
        return Client.get(`${resource}/ShotAppointments/` + dateAndLocation, {
            withCredentials: true, responseType: 'json', headers: { 'Content-Type': 'application/json'}
          })
    },
};

